export default __webpack_public_path__ + "static/media/marcin.b7fb6f06.jpg";